/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-25 10:00:00                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-26 16:33:37                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * Validator
  * TechnicianForm: Create/edit technician form
*/

/* Imports */
import { t } from "i18next";
/***/

/* Services */
import { validator } from "../../../services/form-validator/form-validator";
import TechnicianAttributesForm, { TechnicianAttributesFormValidator } from "./TechnicianAttributesForm";
import { embeddedFormChange } from "../../../services/utils/utils";
import LanguageSelect from "../language/LanguageSelect";
import TechnicianVanSelect from "../technician-van/TechnicianVanSelect";
/***/

/* Validator */
export const TechnicianFormValidator = {
  firstName: (e: unknown) => validator.isString(e),
  lastName: (e: unknown) => validator.isString(e),
  attributes: (e: unknown) => validator.isFormValid(e, TechnicianAttributesFormValidator)
};

/***/

/**
* TechnicianForm: Create/edit technician form 
* @param data - Data to edit
* @param onChange - On change event, trigger on field change
* @param onSubmit - On submit event, trigger enter key down on field
* @param submitted - is form submitted
*/
export default function TechnicianForm({
  data,
  onChange,
  onSubmit,
  submitted
}: {
  data?: EasyTech.Technician,
  onChange: (name: string, value: any) => void,
  onSubmit: () => void,
  submitted?: boolean
}) {
  return (
    <>
      <div className="field">
        <label htmlFor="firstName">{t("common:firstName")}</label>
        <input type="text"
                value={data?.firstName || ""} disabled />
      </div>

      <div className="field">
        <label htmlFor="lastName">{t("common:lastName")}</label>

        <input type="text"
                value={data?.lastName || ""} disabled />
      </div>

      <div className="field">
        <label htmlFor="email">{t("common:email")}</label>

        <input type="text"
                value={data?.email || ""} disabled />
      </div>

      <div className="field">
        <label htmlFor="email">{t("common:language")}</label>
        <LanguageSelect value={data?.language} onChange={(value) => onChange("language", value)} /> 
      </div>

      <TechnicianAttributesForm data={data?.attributes || {} as EasyTech.TechnicianAttributes}
                                onChange={(name, value) => embeddedFormChange(data, "attributes", name, value, onChange)}
                                submitted={submitted}
                                onSubmit={onSubmit}/>

      <div className="field">
        <label htmlFor="email">{t("technician:van")}</label>
        <TechnicianVanSelect value={data?.van} onChange={(value) => onChange("van", value)} />
      </div>
    </>
  );
}
/***/
